module.exports = __webpack_public_path__ + "img/y-58.fbda0474.png";